import API, { baseURL } from './api';
import { getSucursalInfo, getUserInfo } from './auth';

// Client for sge_infantil_core's routes/consuption.js (mounted at /api/consuption —
// the "consuption" spelling matches the real, mounted backend route; not a typo to fix).
export async function listConsumptions(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/consuption/${id}`);
}

export async function createConsumption(payload) {
  const sucursalId = getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/consuption`, { sucursalId, createdBy: getUserInfo()?.id, ...payload });
}

export async function deleteConsumption(id) {
  return API.delete(`${baseURL}api/consuption/${id}`);
}
